import React, { useState } from "react";
import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { ColoredTooltips, Primary } from "../../../../Constant";
import { COLOR_TOOLTIP_DATA, COLOR_TOOLTIP_LIST } from "../../../../Data/UiKit/Tooltip";
import { Btn, ToolTip } from "../../../../AbstractElements";
import CommonTooltip from "../Common/CommonTooltip";

const ColoredTooltip = () => {
  const [tooltip, setTooltip] = useState(false);
  const toggle = () => setTooltip(!tooltip);
  return (
    <Col md="6">
      <Card>
        <CommonCardHeader title={ColoredTooltips} span={COLOR_TOOLTIP_DATA} />
        <CardBody>
          <div className="common-flex">
            <Btn color="primary" className="mb-0 me-0" id="Tooltip-3">{Primary}</Btn>
            <ToolTip target="Tooltip-3" placement="top" isOpen={tooltip} toggle={toggle}>Primary</ToolTip>
            {COLOR_TOOLTIP_LIST.map((item, index) => (
              <CommonTooltip key={index} item={item} />
            ))}
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default ColoredTooltip;
